import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { recipes } from '../services/api';
import Avatar from '../components/Avatar';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer } from '../utils/animations';
import '../styles/Favorites.css';

const Favorites = () => {
  const [favoriteRecipes, setFavoriteRecipes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchFavorites();
  }, []);

  const fetchFavorites = async () => {
    try {
      const response = await recipes.getFavorites();
      setFavoriteRecipes(response.data);
    } catch (error) {
      console.error('Fetch favorites error:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="container"><p>Betöltés...</p></div>;
  }

  return (
    <div className="favorites-page">
      <div className="container">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          <h1>Kedvenc Receptjeim</h1>
          <p className="subtitle">
            {favoriteRecipes.length > 0
              ? `${favoriteRecipes.length} kedvenc recept`
              : 'Még nincs kedvenc recepted'}
          </p>
        </motion.div>

        {favoriteRecipes.length > 0 ? (
          <motion.div
            className="recipes-grid"
            initial="hidden"
            animate="visible"
            variants={staggerContainer}
          >
            {favoriteRecipes.map(recipe => (
              <Link key={recipe._id} to={`/recipe/${recipe._id}`} className="recipe-card card">
                <div className="recipe-card-image-wrapper">
                  {recipe.coverImage ? (
                    <img
                      src={typeof recipe.coverImage === 'object' ? recipe.coverImage.medium : recipe.coverImage}
                      alt={recipe.title}
                      className="recipe-card-image"
                    />
                  ) : (
                    <div className="recipe-card-no-image">📷</div>
                  )}
                </div>
                <div className="recipe-card-body">
                  <h3>{recipe.title}</h3>
                  <div className="recipe-meta">
                    <span className="recipe-meta-item">
                      <span className="meta-icon">⚡</span>
                      {recipe.difficulty || 'Könnyű'}
                    </span>
                    <span className="recipe-meta-item">
                      <span className="meta-icon">⏱️</span>
                      {recipe.prepTime + recipe.cookTime} perc
                    </span>
                    <span className="recipe-meta-item">
                      <span className="meta-icon">👥</span>
                      {recipe.servings} adag
                    </span>
                  </div>
                  {recipe.author && (
                    <div className="recipe-card-author">
                      <Avatar
                        name={recipe.author.nickname || recipe.author.name}
                        imageUrl={recipe.author.profileImage}
                        size="small"
                      />
                      <span className="recipe-card-author-name">{recipe.author.nickname || recipe.author.name}</span>
                    </div>
                  )}
                </div>
              </Link>
            ))}
          </motion.div>
        ) : (
          <div className="empty-state">
            <p>Kezdj el recepteket kedvencelni!</p>
            <a href="/recipes" className="btn btn-primary">
              Receptek böngészése
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default Favorites;
